import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bind-error-modal-content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/bind_error.png",
  alt: "",
  class: "bind-error-img"
}, null, -1)
const _hoisted_3 = { class: "bind-error-modal-title" }
const _hoisted_4 = { class: "bind-error-modal-text" }
const _hoisted_5 = {
  key: 0,
  class: "bind-error-goods",
  style: {"margin-top":"30px","padding-bottom":"30px","background":"#F9F9F9"}
}
const _hoisted_6 = { class: "bind-error-goods-content" }
const _hoisted_7 = { class: "bind-error-goods-title" }
const _hoisted_8 = { class: "bind-error-goods-item flex-center" }
const _hoisted_9 = { class: "bind-error-goods-img" }
const _hoisted_10 = { class: "bind-error-info" }
const _hoisted_11 = { class: "bind-error-info-title" }
const _hoisted_12 = { class: "text" }
const _hoisted_13 = { class: "bind-error-prop" }
const _hoisted_14 = { class: "bind-error-goods" }
const _hoisted_15 = { class: "bind-tag" }
const _hoisted_16 = { class: "bind-error-goods-img" }
const _hoisted_17 = { class: "bind-error-info" }
const _hoisted_18 = { class: "bind-error-info-title" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "text" }
const _hoisted_21 = { class: "bind-error-prop" }
const _hoisted_22 = { class: "bind-error-code" }
const _hoisted_23 = { class: "bind-code-content" }
const _hoisted_24 = { class: "code" }
const _hoisted_25 = { style: {"max-width":"200px"} }
const _hoisted_26 = { class: "number cursor-pt" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "bind-error-btn" }

import { t } from '@/plugins/i18n'
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useSite, isJA } from '@/store'
import { apiShopIcon } from '@/common/const'
import LogoIcon from '@/components/common/LogoIcon.vue'
import Image from '@/components/common/Image.vue'

export default /*#__PURE__*/_defineComponent({
  props: ['productList'],
  setup(__props, { expose }) {

const props = __props

const router = useRouter()
const errorInfo: any = ref({})
const dialogVisible = ref(false)
const open = (info: any) => {
  errorInfo.value = info
  dialogVisible.value = true
}
const jump = (item: { shopItemId: string }) => {
  window.open(`/${useSite()}/product/CreateAssociated?shopItemId=${item.shopItemId}&productSku=${skuInfo.value?.activeSku?.productSku}`)
}
const skuInfo = computed(() => {
  if (errorInfo.value.productSku) {
    const detail = props.productList.find((i) => i.productCode === errorInfo.value.productCode)
    detail.activeSku = detail.skuList.find((i) => i.productSku === errorInfo.value.productSku)
    return detail
  }
  return {}
})
expose({
  open
})

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event)),
    width: "516",
    "custom-class": "bind-error-modal-dialog",
    "show-close": false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('抱歉，绑定失败')), 1),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('原因：该商品已被其他销售商品绑定，需要先解绑后才能绑定该商品。')), 1),
        (_unref(skuInfo).productCode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('供货商品')), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(Image, {
                      src: _unref(skuInfo).productMainImg,
                      alt: ""
                    }, null, 8, ["src"])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(LogoIcon, {
                        type: _unref(skuInfo).platformType,
                        class: "logo-icon"
                      }, null, 8, ["type"]),
                      _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(skuInfo).productTitle), 1)
                    ]),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(((_unref(isJA)() ? _unref(skuInfo).activeSku?.productPropertiesNameJa : null) ?? _unref(skuInfo).activeSku?.productPropertiesName)?.replace(/[+-]?\d+:[+-]?\d+:/ig, '')), 1)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(t)('当前被该商品绑定')), 1),
          _createVNode(_component_el_scrollbar, { "max-height": "250px" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errorInfo.value.bindedShopSkuInfoList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "bind-error-goods-content",
                  key: index
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["bind-error-goods-item flex-center", {'no-border': index === 0}])
                  }, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(Image, {
                        src: item.thirdItemImage,
                        alt: ""
                      }, null, 8, ["src"])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("img", {
                          src: _unref(apiShopIcon)[item.thirdPlatformType],
                          alt: "",
                          class: "logo"
                        }, null, 8, _hoisted_19),
                        _createElementVNode("div", _hoisted_20, _toDisplayString(item.thirdItemName), 1)
                      ]),
                      _createElementVNode("div", _hoisted_21, _toDisplayString(item.thirdItemAttribute), 1),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(t)('编号')), 1),
                          _createVNode(_component_el_tooltip, {
                            effect: "light",
                            placement: "top",
                            "popper-class": "tool-tip-no-border"
                          }, {
                            content: _withCtx(() => [
                              _createElementVNode("div", _hoisted_25, _toDisplayString(item.thirdSkuCode), 1)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_26, _toDisplayString(item.thirdSkuCode), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createElementVNode("div", {
                          class: "bind-error-code-btn",
                          onClick: ($event: any) => (jump(item))
                        }, _toDisplayString(_unref(t)('查看商品绑定关系')), 9, _hoisted_27)
                      ])
                    ])
                  ], 2)
                ]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_component_el_button, {
            type: "primary",
            class: "btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('我知道了3')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})